import React from "react";
import "./Loader.css";
import { Loader as LoaderIcon } from 'react-feather';

export default function Loader() {
  return (
    <LoaderIcon className="loader-spinning" size={42} />
  );
}